export const companyConfig = {
  name: "COEFFICIENT PARTNERS",
  logo: "/cpm.png", 
  address: "C - 56/5, Second Floor, Mantech Tower, Block B, Industrial Area, Sector 62, Noida Uttar pradesh 201309",
  email: "info@coefficient.com",
  phone: "+91 93198 98369",
  website: "https://coefficient.in/",
  gstin: "27AAAAA0000A1Z5",
  bankDetails: {
    accountName: "Your Tech Solutions Pvt Ltd",
    accountNo: "009988776655",
    bankName: "HDFC Bank",
    ifsc: "HDFC0001234",
    branch: "MG Road Branch"
  },
  terms: [
    "Goods once sold will not be taken back.",
    "Interest @18% p.a. will be charged if payment is not made within due date.",
    "Subject to local jurisdiction."
  ],
  privacyPolicyUrl: "https://yourtech.com/privacy-policy"
};